let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kTBMy")).then(() => parcelRequire('6Xyby'));